import * as React from "react"
import { Link, FieldProps, useRecordContext } from "react-admin"
import { SxProps, Avatar, Typography } from "@mui/material"

import PdfIcon from "@mui/icons-material/PictureAsPdf"

import { Order } from "../types"

const OrderLinkField = (props: FieldProps<Order>) => {
  const record = useRecordContext<Order>()

  // console.log("pdf record", record);  

  const handleDownload = (pdfBookData : any) => {

    // console.log("pdfBookData=====>>>>>>>>>>>.=", pdfBookData);    

    if (!pdfBookData || !Array.isArray(pdfBookData)) return;
  
    pdfBookData.forEach((url, index) => {      
      const link = document.createElement("a");
      link.href = url.book_pdf_url;
      link.target = "_blank";
      link.setAttribute("download", `document-${index + 1}.pdf`); // Suggested filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };


  if (!record.bookData || !record.bookData[0].book_pdf_url) {
    return (
      <Typography
        variant="body2"
        display="flex"
        flexWrap="nowrap"
        alignItems="center"
        component="div"
        sx={{
          mr: 1,
          mt: -0.5,
          mb: -0.5,
        }}
      >
        ---
      </Typography>
    )
  }
  const size = 100
  return (
     <a target="_blank" onClick={() => handleDownload(record?.bookData)}>
      <Typography
        variant="body2"
        display="flex"  
        flexWrap="nowrap"
        alignItems="center"
        component="div"
        sx={{
          mr: 1,
          mt: -0.5,
          mb: -0.5,
        }}        
      >
        <PdfIcon />
      </Typography>
     </a>
  )
}

OrderLinkField.defaultProps = {
  source: "order_number",
}

export default OrderLinkField
